/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Gender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE'
} as const;
export type Gender = typeof Gender[keyof typeof Gender];

